<script setup>
	import HomeCard from "@/components/home/HomeCard.vue";
</script>

<template>
	<section class="card-section">
		<HomeCard fileName="home-card-1.json" />
		<HomeCard fileName="home-card-2.json" />
		<HomeCard fileName="home-card-3.json" />
	</section>
</template>

<style scoped>
.card-section {
	margin-top: 2rem;
	margin-bottom: 100px;
	width: 100%;
	background-color: transparent;
	display: flex;
	justify-content: space-evenly;
	flex-wrap: wrap;
	gap: 0.625rem;
}
</style>